var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Button, ButtonGroup, ModalBody, ModalFooter, Typography, } from '@one-thd/sui-atomic-components';
import React, { useState } from 'react';
var Step1Props = {
    icon: (React.createElement("img", { src: "https://assets.thdstatic.com/images/v1/BackupFiles.svg", alt: "Backup Files", width: "140px", height: "140px" })),
    title: 'Back Up Data Before Importing',
    description: 'Create a backup of your company data in QuickBooks.',
};
var Step2Props = {
    icon: (React.createElement("img", { src: "https://assets.thdstatic.com/images/v1/ImportFiles.svg", alt: "Import Files", width: "260px", height: "130px" })),
    title: 'Open the Imported File',
    description: 'Open QuickBooks. Select File > Utilities > Import > IIF Files from the File dropdown menu in QuickBooks to start the process.',
};
var Step3Props = {
    icon: (React.createElement("img", { src: "https://assets.thdstatic.com/images/v1/Find.svg", alt: "Find", width: "140px", height: "150px" })),
    title: 'Back Up Data Before Importing',
    description: 'Look for the newly imported file in your Downloads folder and select "Open".',
};
var Step4Props = {
    icon: (React.createElement("img", { src: "https://assets.thdstatic.com/images/v1/UploadComplete.svg", alt: "Upload Complete", width: "130px", height: "120px" })),
    title: "You're all Set!",
    description: "You've successfully imported your IIF file. You can view your newly imported file in your Credit Cards Activities.",
};
var StepTemplate = function (props) {
    var icon = props.icon, title = props.title, description = props.description;
    return (React.createElement("div", null,
        icon,
        React.createElement("div", { className: "sui-py-1" },
            React.createElement(Typography, { align: "center", variant: "body-lg", weight: "bold" }, title)),
        React.createElement("div", { className: "sui-py-1" },
            React.createElement(Typography, { align: "center", variant: "body-base" }, description))));
};
var QBWalkthroughStepper = {
    1: React.createElement(StepTemplate, __assign({}, Step1Props)),
    2: React.createElement(StepTemplate, __assign({}, Step2Props)),
    3: React.createElement(StepTemplate, __assign({}, Step3Props)),
    4: React.createElement(StepTemplate, __assign({}, Step4Props)),
};
var handleNextClick = function (currentStep, setCurrentStep) {
    if (currentStep === 4) {
        setCurrentStep(1);
    }
    else {
        setCurrentStep(currentStep + 1);
    }
};
var QBDesktopExportWalkthrough = function (props) {
    var setQBRenderFlag = props.setQBRenderFlag;
    var _a = useState(1), currentStep = _a[0], setCurrentStep = _a[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalBody, null, QBWalkthroughStepper[currentStep]),
        React.createElement(ModalFooter, { position: "end" },
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { onClick: function () {
                        setQBRenderFlag(undefined);
                    } }, "Go Back"),
                React.createElement(Button, { onClick: function () { return handleNextClick(currentStep, setCurrentStep); } }, "Next")))));
};
export default QBDesktopExportWalkthrough;
